import { Navigate, useParams } from 'react-router-dom'
import { useDocumentTitle } from '../../../common/useDocumentTitle'
import { IntegrationServiceId } from '../../../common/integrations'
import { Col, Container, Row } from 'react-bootstrap'
import { IntegrationRow } from './IntegrationRow'
import { IntegrationManagementTabs } from './IntegrationManagementTabs'
import React from 'react'

export const IntegrationManagement: React.FC = () => {
  const { serviceId } = useParams<{ serviceId: string }>() as { serviceId: IntegrationServiceId }
  useDocumentTitle(`Manage ${serviceId}`)
  if (!Object.values<string>(IntegrationServiceId).includes(serviceId)) {
    return <Navigate to='/account/integration-settings/integrations' replace />
  }

  return (
    <div className='full-size-content'>
      <Container fluid>
        <Row className='mb-9'>
          <IntegrationRow serviceId={serviceId} />
        </Row>
        <Row>
          <Col lg={12}>
            <IntegrationManagementTabs />
          </Col>
        </Row>
      </Container>
    </div>
  )
}
